/** Monitoring dashboard card icon. See SecuritySummaryIcon.tsx for the currentColor rationale. */
export function MonitoringIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.49998 1.25H7.49998V3.5H8.49998V1.25Z" fill="currentColor" />
      <path
        d="M4.43414 1.75195L5.65846 3.89452C5.33205 4.00794 5.0232 4.14133 4.73192 4.28863L3.56589 2.24809L4.43414 1.75195Z"
        fill="currentColor"
      />
      <path
        d="M10.3416 3.89454C10.668 4.00796 10.9768 4.14135 11.2681 4.28866L12.4341 2.24809L11.5659 1.75195L10.3416 3.89454Z"
        fill="currentColor"
      />
      <path
        d="M8.00006 4.5C6.35849 4.5 4.9199 5.18341 3.81755 6.04324C2.71992 6.89939 1.91408 7.96234 1.54316 8.79692C1.47938 8.94041 1.48672 9.10554 1.56298 9.24281C2.0069 10.0419 2.79732 11.095 3.87619 11.9537C4.95725 12.8141 6.35546 13.5 8.00006 13.5C8.62262 13.5 9.20988 13.4017 9.75799 13.2329L8.93479 12.4097C8.63327 12.4683 8.32145 12.5 8.00006 12.5C6.64466 12.5 5.45954 11.9358 4.49893 11.1713C3.63441 10.4832 2.97405 9.64952 2.56632 8.97903C2.9057 8.33764 3.55309 7.51774 4.43258 6.83175C5.41355 6.06659 6.64164 5.5 8.00006 5.5C9.35849 5.5 10.5866 6.06659 11.5675 6.83175C12.447 7.51774 13.0944 8.33764 13.4338 8.97903C13.1277 9.48234 12.6793 10.0776 12.109 10.6342L12.8162 11.3414C13.5452 10.628 14.0944 9.85968 14.4371 9.24281C14.5134 9.10554 14.5207 8.94041 14.457 8.79692C14.086 7.96234 13.2802 6.89939 12.1826 6.04324C11.0802 5.18341 9.64164 4.5 8.00006 4.5Z"
        fill="currentColor"
      />
      <path
        d="M7.99998 10C8.55226 10 8.99998 9.55229 8.99998 9C8.99998 8.44771 8.55226 8 7.99998 8C7.44769 8 6.99998 8.44771 6.99998 9C6.99998 9.55229 7.44769 10 7.99998 10Z"
        fill="currentColor"
      />
      <path
        d="M7.99998 12C8.64788 12 9.24781 11.7946 9.73821 11.4454L12.1464 13.8536L12.8535 13.1465L10.4453 10.7383C10.7946 10.2479 11 9.64793 11 9C11 7.34315 9.65683 6 7.99998 6C6.34312 6 4.99998 7.34315 4.99998 9C4.99998 10.6569 6.34312 12 7.99998 12ZM7.99998 11C6.89541 11 5.99998 10.1046 5.99998 9C5.99998 7.89543 6.89541 7 7.99998 7C9.10455 7 9.99998 7.89543 9.99998 9C9.99998 10.1046 9.10455 11 7.99998 11Z"
        fill="currentColor"
      />
    </svg>
  );
}
